<template>
  <div class="about">
    <a-row class="about-head">
      <a-col :span="12">
        <p>系统设置</p>
      </a-col> 
    </a-row>
    <a-layout style="background-color: #576371;min-height: 90vh;">
      <a-layout-header class="about-title" style="background-color: #576371;">
        <h1>{{title}}</h1>
      </a-layout-header>
      <a-layout-content style="background-color: #576371;">  
        <a-row class="about-con">
          <router-link tag="div" style="float:left" to="/setup">门限设置</router-link>
          <router-link tag="div" style="text-align:right" to="/setup">></router-link>    
        </a-row>
        <a-row class="about-con">
          <router-link tag="div" style="float:left" to="/usermanage">账号管理</router-link>
          <router-link tag="div" style="text-align:right" to="/usermanage">></router-link>     
        </a-row> 
        <a-row class="about-con">
          <router-link tag="div" style="float:left" to="/abouts">关于我们</router-link>
          <router-link tag="div" style=" text-align:right" to="/abouts">></router-link>    
        </a-row>
        <div class="Setup-button"> 
          <a-button type="primary" @click="exit">退出登录</a-button> 
        </div> 
      </a-layout-content> 
      <a-layout-footer class="about-footer" style="background-color: #576371;">
        <div>
          <img src="../assets/images/about_logo.png" alt width="200" />
        </div>
        <p>深圳市荣盛智能装备有限公司</p>
      </a-layout-footer>
    </a-layout> 
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import SetupService from "../api/SetupService";
export default {
  components: {},
  data() {
    return {
      title: "SAS应急单兵作战系统",
      LoreVersion: "",
      Updatestimer: null,
      GetLoreVersiontimer: null,
      versions: null, 
      LatestVersion: "0.0.1",
      CheckUpdatesmag: "",
      visible: false,
      ISUpdates: false, 
      percent: 0
    };
  },
  computed: {
    Config() {
      return this.$store.state.Config;
    }
  },
  mounted() { 
    
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },  
    exit() {
      let _this = this;
      this.$confirm({
        title: "确定退出登录吗",
        // content: "原设置的值将会丢失",
        okText: "退出",
        cancelText: "取消",
        centered: true,
        width: 320,
        onOk() {
          sessionStorage.removeItem("Authorization"); 
          _this.$router.push({ name: "Login" }).catch(err => {console.error(err)});
        },
        onCancel() {}
      });
    },
    exitprogram() {
      this.$confirm({
        title: "确定退出程序吗",
        // content: "原设置的值将会丢失",
        okText: "退出",
        cancelText: "取消",
        centered: true,
        width: 320,
        onOk() {
          ipc.quit();
        },
        onCancel() {}
      });
    } 
  } 
};
</script>
<style  lang="less" scoped>
.about-head {
  font-size: 36px;
  color: #fff;
  background-color: #1f2730;
}
.about-head p {
  margin: -5px 0 0 15px;
  //border-left: 5px solid #3fdb23;
  padding: 0 0 0 15px;
}
.about-head p::before {
  font-size: 40px;
  content: "|";
  color: #3fdb23;
  font-weight: bold;
  margin-right: 15px;
}
.about-head a {
  color: #ccc;
}
.about-title {
  color: #fff;
  text-align: center;
  margin: 30px;
}
.about-title h1 {
  color: #fff;
  font-weight: bold;
  font-size: 36px;
}
.about-con {
  padding: 10px 40px 10px 40px;
  background: #778899;
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #576371;
}
.about-footer{
   text-align: center;
    color: #fff;
  font-size: 24px;
}
.about-rear {
  position: absolute;
  bottom: 40px;
  width: 92%;
  text-align: center;
}
.about-rear div {
  margin-bottom: 12px;
}
.about-rear p {
  color: #fff;
  font-size: 24px;
}

.Setup-button {
  margin: 40px;
  text-align: center;
}
.Setup-button button.ant-btn {
  padding: 8px 12px !important;
  font-size: 18px !important;
  height: auto;
  margin: 0 50px;
  width: 150px;
}
</style>
